module.exports = __webpack_public_path__ + "static/beholder-mtg_afr-70ccf168f845b1b6a22977021d9ee76f.jpg";